import { useTranslation } from '../../context/LanguageContext';
import type { UnifiedWallet } from '../auth/useWallet';

export function LoginScreen({ wallet }: { wallet: UnifiedWallet }) {
  const { t } = useTranslation();

  return (
    <div className="win98-window">
      <div className="win98-title-bar">
        <div className="win98-title">
          <i className="fa-solid fa-key" /> {t('sunset.login.title')}
        </div>
      </div>

      <div className="win98-content">
        <p className="win98-text-normal win98-text-bold win98-mb-md">
          {t('sunset.login.notASignup')}
        </p>

        {wallet.privyAuthedWithoutWallet && (
          <div className="win98-modal-error win98-mb-md">
            {t('sunset.login.privyAuthedNoWallet')}
            <div style={{ marginTop: 8 }}>
              <button
                className="win98-button"
                onClick={() => void wallet.disconnect()}
              >
                <i className="fa-solid fa-right-from-bracket" /> {t('sunset.signOut')}
              </button>
            </div>
          </div>
        )}

        <div
          style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16 }}
        >
          <button
            className="win98-button win98-button-primary"
            onClick={wallet.loginWithPrivy}
            disabled={wallet.privyAuthedWithoutWallet}
            style={{ flex: 1, minWidth: 180, padding: '8px 12px' }}
          >
            <i className="fa-solid fa-envelope" />
            <span style={{ marginLeft: 8 }}>{t('sunset.login.signInWithPrivy')}</span>
          </button>
          <button
            className="win98-button"
            onClick={wallet.connectNativeWallet}
            style={{ flex: 1, minWidth: 180, padding: '8px 12px' }}
          >
            <i className="fa-solid fa-wallet" />
            <span style={{ marginLeft: 8 }}>{t('sunset.login.connectWallet')}</span>
          </button>
        </div>

        <div className="win98-sunken" style={{ padding: 12 }}>
          <div className="win98-section-heading win98-mb-xs">
            {t('sunset.login.whichOne')}
          </div>
          <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 1.6 }}>
            <li>{t('sunset.login.privyOption')}</li>
            <li>{t('sunset.login.connectWalletOption')}</li>
          </ul>
        </div>

        <p
          className="win98-text-normal"
          style={{ fontSize: 12, marginTop: 12 }}
        >
          {t('sunset.login.privacyNote')}
        </p>
      </div>
    </div>
  );
}
